"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheData = void 0;
class CacheData {
    constructor(initData, dataSubject) {
        this.dataCache = initData;
        this.subject = dataSubject;
        this.isLocalCache = true;
    }
    updateCache(newData) {
        this.dataCache = newData;
        this.emit();
    }
    getLocalCacheFlag() {
        return this.isLocalCache;
    }
    changeLocalCacheFlag(isLocalCache) {
        this.isLocalCache = isLocalCache;
    }
    getCacheData() {
        return this.dataCache;
    }
    emit() {
        if (this.subject) {
            this.subject.next(this.dataCache);
        }
    }
    getDataSubject() {
        return this.subject;
    }
}
exports.CacheData = CacheData;
